<template>
    <div class="cart-wrapper">
        <header page-transition-group></header>

        <div class="page-content" page-transition-group>
            <div class="container-xxl padding-container">
                <div class="row">
                    <div class="col-12">
                        <h3 class="sf-page-title mb-4">{{$t('Panier d\'achat')}}</h3>
                    </div>
                    <div v-if="cart && cart.selection.length" class="shopping-cart col-12">

                        <div class="row">
                            <div class="col-12">
                                <h4>{{$t('Résumé de la commande')}}</h4>
                            </div>
                        </div>

                        <div class="row row-header">
                            <div class="col-5 col-header">
                                <p>{{$t('Détails')}}</p>
                            </div>
                            <div class="col-2 col-header right">
                                <p class="label-desktop">{{$t('Quantité')}}</p>
                            </div>
                            <div class="col-2 col-header right">
                                <p class="label-desktop">{{$t('Prix unitaire')}}</p>
                            </div>
                            <div class="col-2 col-header right">
                                <p class="label-desktop">{{$t('Total')}}</p>
                            </div>
                            <div class="col-1 col-header right">

                            </div>
                        </div>

                        <div
                            v-for="(cours, index) in cart.selection"
                            :key="'cours-' + index"
                            class="row row-item"
                        >
                            <div class="col-6  col-content">
                                <span>
                                    {{cours.name}}<br/>
                                    <router-link
                                        class=""
                                        :to="{ path: '/formation/' + cours.slug}"
                                        itemtype="https://www.schema.org/SiteNavigationElement"
                                    >
                                        {{ $t('Voir la formation') }}
                                    </router-link>

                                    <div v-if="cours.preInscription" class="mt-2 pe-4">
                                        <p class="text-legal">Ce cours nécessite une pré-inscription et est payable suite au processus de sélection des candidats et candidates.</p>
                                    </div>
                                </span>
                            </div>

                            <div class="col-6 ">
                                <div class="row">
                                    <div class="col-12 col-md-2 col-content right">
                                        <span class="value label-mobile">{{$t('Quantité')}}</span><span class="value"><input type="number" :value="cours.numberSelected" step="1" max="99" min="1" @change="doUpdateCart($event, cours.formationId)"></span>
                                    </div>
                                    <div class="col-12 col-md-4 col-content right">
                                        <span class="value label-mobile">{{$t('Prix unitaire')}}</span><span class="value">{{parsePrice(cours.priceRegular)}},00$</span>
                                    </div>
                                    <div class="col-12 col-md-4 col-content right">
                                        <span class="value label-mobile">{{$t('Total')}}</span><span class="value">{{parsePrice(coursTotal(cours.priceRegular, cours.numberSelected))}},00$</span>
                                    </div>
                                    <div class="col-12 col-md-2 col-content right">
                                        <button class="remove-item" @click="doRemoveFromCart(cours.formationId)"><i class="fa-regular fa-trash-can icon-trash"></i></button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row row-total">
                            <div class="col-2 col-xl-3 d-none d-lg-block col-content right d-flex order-1"></div>
                            <div class="col-12 col-md-7 col-lg-5 col-xl-4 col-content right d-flex order-4 order-md-2">
                                <p
                                    v-if="HaveReducedPrice()"
                                    class="text-md-start text-end bold"
                                >
                                    {{$t("Si vous êtes admissible à une réduction, elle s’affichera avant le paiement")}}.
                                </p>
                            </div>
                            <div class="col-12 col-md-2 col-content right d-flex order-2 order-md-3">
                                <p class="bold text-uppercase">{{$t('Total')}}</p>
                            </div>
                            <div class="col-12 col-md-2 col-content right d-flex order-3 order-md-4 mb-4 mb-md-0">
                                <p class="bold">{{parsePrice(CartTotal())}},00$</p>
                            </div>
                            <div class="col-1 col-header right d-flex order-1 order-md-5">
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-2 col-xl-3 d-none d-lg-block"></div>
                            <div class="col-12 col-lg-10 col-xl-9">
                                <div class="sep-hor-black "></div>
                            </div>
                        </div>

                        <div class="row pt-4" v-if="globalsIsLoaded">
                            <div class="col-12 d-flex flex-column flex-md-row justify-content-end">
                                <div class="" v-for="(item, i) in globals.inisGlobalElement.messagesDeValidation" :key="i">
                                    <p class="error alert" v-if="item.label === cartSelectionStatus">
                                        {{ item.message }}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="row pt-4">
                            <div class="col-12 d-flex flex-column flex-md-row justify-content-end">

                                <a :href="salesforceRedirectUrl" class="button mb-3 mb-md-0 me-md-3" v-if="cartSelectionStatus === 'valid' || cartSelectionStatus === 'valid-full'">{{$t('Débuter l’inscription')}}</a>
                                <router-link
                                    :to="{ name: 'Formations-fr' }"
                                    class="button secondary"
                                    itemtype="https://www.schema.org/SiteNavigationElement"
                                    v-if="cartSelectionStatus === 'valid'"
                                >{{ $t('Ajouter un autre cours') }}</router-link
                                >
                            </div>
                        </div>

                        <div class="row pt-5">
                            <div class="col-12">
                                <p class="text-end mb-2">
                                    <router-link
                                        class=""
                                        :to="{ path: '/conditions-achat' }"
                                        itemtype="https://www.schema.org/SiteNavigationElement"
                                    >
                                        {{$t('Politique d\'achat et de remboursement')}}
                                    </router-link>
                                </p>
                                <p v-if="globalsIsLoaded" class="text-end">{{$t('En cas de problème, communiquez avec L’inis au') + ' ' + globals.contact.inisPhone}}</p>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <div class="row">
                            <div class="col-12 col md-10 col-lg-8">
                                <h4 class="mb-4">{{$t('Il n’y a aucun item dans votre panier. Consultez nos formations pour ajouter un item.')}}</h4>

                                <router-link
                                    :to="{ name: 'Formations-fr' }"
                                    class="button"
                                    itemtype="https://www.schema.org/SiteNavigationElement"
                                    >{{ $t('Voir nos formations') }}</router-link
                                >

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

import { updateCart, bumpCart, removeFromCart } from '@/firebase/init'

export default {
    name: 'Panier',

    watch: {
        pageIsLoaded: {
            async handler(pageIsLoaded) {
                if (pageIsLoaded && !this.nbQtyCart) {
                    // Redirect to formations
                    // this.$router.push({ name: 'Formations-fr' })
                } else {
                    bumpCart(this.cart)
                    if (this.cart) {
                        this.validateCart(this.cart)
                    }
                }
            },
            immediate: true,
        },
    },

    computed: {
        cartSelectionStatus() {
            if (!this.pageIsLoaded) {
                return ''
            }

            if (!this.cart) {
                return ''
            }

            if (!this.cart.selection.length) {
                return ''
            }

            // Check Cart content

            const cartHasLms = this.cart.selection.some(
                (cours) => cours.lms
            )

            const cartHasCreation = this.cart.selection.some(
                (cours) => cours.type === 'creation'
            )

            const cartHasPreInscription = this.cart.selection.some(
                (cours) => cours.preInscription
            )

            const cartHasOther = this.cart.selection.some(
                (cours) => cours.type !== 'creation'
            )

            const cartHasOther2 = this.cart.selection.some(
                (cours) => !cours.preInscription
            )

            const cartHasOther3 = this.cart.selection.some(
                (cours) => !cours.lms
            )

            if (cartHasCreation && cartHasOther) {
                return 'creation-mixed'
            }

            if (cartHasPreInscription && cartHasOther2) {
                return 'preinscription-mixed'
            }

            if (cartHasLms && cartHasOther3) {
                return 'lms-mixed'
            }

            if (cartHasCreation) {
                let qty = 0
                const nbCreation = this.cart.selection.filter(
                    (cours) => cours.type === 'creation'
                )

                nbCreation.forEach((cours) => {
                    qty += cours.numberSelected
                })

                if (qty > 1) {
                    return 'multiple-creation'
                }

                return 'valid-full'
            }

            if (cartHasLms) {
                let qty = 0
                const nbLms = this.cart.selection.filter(
                    (cours) => cours.lms
                )

                nbLms.forEach((cours) => {
                    qty += cours.numberSelected
                })

                if (qty > 1) {
                    return 'multiple-lms'
                }

                return 'valid-full'
            }

            if (cartHasPreInscription) {
                let qty = 0
                const nbPreinscription = this.cart.selection.filter(
                    (cours) => cours.preInscription
                )

                nbPreinscription.forEach((cours) => {
                    qty += cours.numberSelected
                })

                if (qty > 1) {
                    return 'multiple-preinscription'
                }

                return 'valid-full'
            }

            const hasCreationNotValid = this.cart.selection.some(
                (cours) => cours.type === 'creation' && (cours.subscriptionDate < new Date().toISOString().slice(0, 10) || cours.deactivated)
            )

            const hasCoursNotValid = this.cart.selection.some(
                (cours) => cours.type !== 'creation' && cours.startDate < new Date().toISOString().slice(0, 10) || cours.deactivated || parseInt(cours.placeAvailable) <= 0
            )

            if (hasCreationNotValid) {
                return 'creation-invalid'
            }

            if (hasCoursNotValid) {
                return 'cours-invalid'
            }

            return 'valid'
        },
        redirectName() {
            if (!this.pageIsLoaded || !this.nbQtyCart) {
                return ''
            }

            const findIndex = this.cart.selection.findIndex(item => item.type === 'creation')
            const hasCreation = findIndex > -1
            return hasCreation ? btoa(this.cart.selection[findIndex].name) : btoa(`Panier d'achat`)
        },
        cartId() {
            if (!this.pageIsLoaded || !this.nbQtyCart) {
                return ''
            }

            return this.cart.id
        },
        salesforceRedirectUrl() {
            if (!this.pageIsLoaded || !this.cartId || !this.redirectName) {
                return ''
            }

            const mockUrl = `${this.globals.salesforce.salesforceUrl}mon-panier?redirectName=${this.redirectName}&cartId=${this.cartId}`

            return mockUrl
        },
        nbQtyCart() {
            const items = this.cart ? this.cart.selection : []
            let qty = 0
            for (let i = 0; i < items.length; i++) {
                qty += parseInt(items[i].numberSelected)
            }
            return qty
        },
        pageIsLoaded() {
            return this.contentIsLoaded && this.globalsIsLoaded
        },
        ...mapState(['contentIsLoaded', 'globalsIsLoaded']),
        ...mapGetters(['seo', 'content', 'globals', 'cart', 'bgTheme']),
    },

    methods: {
        ...mapActions(['validateCart']),
        doUpdateCart(e, formationId) {
            // console.log(this.cart.id, formationId, e.target.value)
            updateCart(this.cart, formationId, e.target.value)
        },
        coursTotal(unitprice, qt) {
            var total = unitprice * qt
            return total;
        },
        CartTotal() {
            let total = 0
            this.cart.selection.forEach(calculateTotal);
            function calculateTotal(item) {
                total += item.numberSelected * item.priceRegular
            }
            return total;
        },
        HaveReducedPrice() {
            let reduced = false
            this.cart.selection.forEach(checkReduce);
            function checkReduce(item) {
                if(item.type === 'pour-professionnel-le-de-laudiovisuel' || item.priceReduced !== 0 || item.preInscription){
                    reduced = true
                }
            }
            return reduced;
        },
        parsePrice(price) {
            if (!price) {
                return 0
            }

            return price.toLocaleString().replaceAll(',', ' ')
        },
        async doRemoveFromCart(formationId) {
            await removeFromCart(this.cart, formationId)

            if (!this.nbQtyCart) {
                // Redirect to formations
                // this.$router.push({ name: 'Formations-fr' })
            }
        },
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.alert {
    text-align: center;
    color: #dc3545;
    border-color: #dc3545;
    padding: 10px;
    margin-bottom: 20px;
    border: 1px solid #dc3545;
    border-left: 5px solid #dc3545;
    border-radius: 4px;
}
</style>
